import React from "react";
import Provider from "./Provider";
export default function ConditionProvider(props) {
    const { provider } = props;
    if (!provider.whenTrue ||
        !provider.whenFalse ||
        !provider.testedValue ||
        !provider.greaterThan) {
        props.onProviderUpdate(Object.assign(Object.assign({}, provider), { testedValue: { type: "constant", value: 0 }, greaterThan: { type: "constant", value: 1 }, whenTrue: { type: "constant", value: 2 }, whenFalse: { type: "constant", value: -2 } }));
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", null,
        "Je\u017Celi:",
        React.createElement("div", { className: "sum-provider-item" },
            React.createElement(Provider, { hasHiddenType: props.hasHiddenType, provider: provider.testedValue, onProviderUpdate: (newP) => props.onProviderUpdate(Object.assign(Object.assign({}, provider), { testedValue: newP })), formatNames: props.formatNames })),
        React.createElement("br", null),
        "Jest wi\u0119ksza ni\u017C:",
        React.createElement("div", { className: "sum-provider-item" },
            React.createElement(Provider, { provider: provider.greaterThan, hasHiddenType: props.hasHiddenType, onProviderUpdate: (newP) => props.onProviderUpdate(Object.assign(Object.assign({}, provider), { greaterThan: newP })), formatNames: props.formatNames })),
        React.createElement("br", null),
        "To zwr\u00F3\u0107:",
        React.createElement("div", { className: "sum-provider-item" },
            React.createElement(Provider, { hasHiddenType: props.hasHiddenType, provider: provider.whenTrue, onProviderUpdate: (newP) => props.onProviderUpdate(Object.assign(Object.assign({}, provider), { whenTrue: newP })), formatNames: props.formatNames })),
        React.createElement("br", null),
        "W przeciwnym razie zwr\u00F3\u0107:",
        React.createElement("div", { className: "sum-provider-item" },
            React.createElement(Provider, { hasHiddenType: props.hasHiddenType, provider: provider.whenFalse, onProviderUpdate: (newP) => props.onProviderUpdate(Object.assign(Object.assign({}, provider), { whenFalse: newP })), formatNames: props.formatNames }))));
}
